import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Short Access Component
 *
 * Handles short-time access code authentication and navigation.
 *
 * Note: This component requires application-specific services:
 * - AuthService (with storeAuthentication method)
 * - ShortTimeAccessCodeService (with generateAccessToken method)
 *
 * Each application should provide these services and use this component as a template
 * or extend it with their own implementation.
 *
 * Example route:
 * ```typescript
 * {
 *   path: 'short-access/:accessCode',
 *   component: ShortAccessComponent,
 *   providers: [ShortTimeAccessCodeService]
 * }
 * ```
 */
@Component({
	selector: 'short-access',
	templateUrl: './short-access.component.html',
	styleUrls: ['./short-access.component.scss'],
	imports: [ReactiveFormsModule, TranslateModule],
})
export class ShortAccessComponent implements OnInit {
	protected errorMessage: string = '';

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly router: Router
	) {}

	ngOnInit(): void {
		// This is a template component
		// Each application should implement their own short-access logic
		// based on their AuthService and ShortTimeAccessCodeService

		this.activatedRoute.params.subscribe((params) => {
			const accessCode: string = params['accessCode'];

			if (accessCode) {
				// Application-specific implementation goes here
				console.warn('ShortAccessComponent: Implement your own short access logic');
				this.errorMessage = 'Short access component requires application-specific implementation';
			}
		});
	}

	private decodeHtmlAndShowPage(page: string): void {
		// Utility function for HTML decoding
		const textarea = document.createElement('textarea');
		textarea.innerHTML = page;
		const safePageUrl = textarea.value;
		this.router.navigateByUrl(safePageUrl);
	}
}
